
<template>
   <div class="wrapper">
        <div class="content">
            <img src="../../assets/img/404.png" alt="">
            <!-- <div>立即刷新</div> -->
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
    * {
            margin: 0;
            padding: 0;
        }
        .wrapper{
            width: 100%;
            overflow: hidden;
        }
        .wrapper .content {
            width: 90%;
            margin:140px auto;
        }
        .wrapper .content p{
            font-size:16px;
            text-align: center;
        }
        /* .wrapper .content div{
            width:141px;
            height:42px;
            border-radius:21px;
            border:1px solid rgba(107,222,173,1);
            font-size:14px;
            color:#6BDEAD;
            text-align: center;
            line-height: 42px;
            margin:20px auto;
        } */
</style>



// WEBPACK FOOTER //
// src/components/main/Login.vue